module.exports = __webpack_public_path__ + "static/media/delete-svgrepo-com (2).1239db40.svg";